import { PAGINGATION_DEFAULT } from '@const/pagination'
import { fetchSingle } from '@store/bannerNotificationManagementStore/slice'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { fetchBannerNotificationList } from './asyncAction'

const initialState: TBannerNotificationManagement.TState = {
  notificationList: {
    data: [],
    ...PAGINGATION_DEFAULT
  },
  isFetchingNotificationList: true,
  notificationUpsert: {
    data: {
      id: '',
      content: '',
      startDate: null,
      endDate: null,
      destinationUrl: ''
    },
    errors: [
      { key: 'content', message: '' },
      { key: 'startDate', message: '' },
      { key: 'endDate', message: '' },
      { key: 'destinationUrl', message: '' }
    ]
  },
  isLoading: false
}
const bannerNotificationManagementSlice = createSlice({
  name: 'bannerNotificationManagement',
  initialState,
  reducers: {
    changeStartDate (state, action) {
      state.notificationUpsert.data.startDate = action.payload
    },
    changeEndDate (state, action) {
      state.notificationUpsert.data.endDate = action.payload
    },
    handleChangeInsertMessage (state, action) {
      state.notificationUpsert.data.content = action.payload.content
    },
    addError (state, action) {
      const { key, message } = action.payload
      const errors = state.notificationUpsert.errors
      const updatedError = errors.filter(x => x.key === key)[0]
      if (updatedError) {
        updatedError.message = message
      }
    },
    setIsLoading (state, action) {
      state.isLoading = action.payload
    },
    resetFormValue () {
      return initialState
    },
    changeDestinationUrl (state, action) {
      state.notificationUpsert.data.destinationUrl = action.payload
    }
  },
  extraReducers: builder => {
    builder
      .addCase(fetchBannerNotificationList.fulfilled, (state, action: PayloadAction<TBannerNotificationManagement.TState['notificationList']>) => {
        if (!action.payload?.data) return
        state.notificationList = {
          ...action.payload
        }
        state.isFetchingNotificationList = false
      })
      .addCase(fetchBannerNotificationList.pending, state => {
        state.isFetchingNotificationList = true
      })
      .addCase(fetchSingle.fulfilled, (state, action: PayloadAction<TBannerNotificationManagement.TState['notificationUpsert']>) => {
        state.isLoading = false
        if (!action.payload?.data) return
        state.notificationUpsert.data = action.payload.data
        state.notificationUpsert.errors = initialState.notificationUpsert.errors
      })
      .addCase(fetchSingle.pending, state => {
        state.isLoading = true
      })
  }
})

export * from './asyncAction'

export const {
  changeStartDate,
  changeEndDate,
  addError,
  handleChangeInsertMessage,
  setIsLoading,
  resetFormValue,
  changeDestinationUrl
} = bannerNotificationManagementSlice.actions

export const bannerNotificationManagementReducer = bannerNotificationManagementSlice.reducer
